import React from 'react';
import { List } from 'immutable';
import { useTranslation } from 'react-i18next';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';
import format from '../../../../helpers/date';

import {
  Hero,
  Breadcrumbs,
  WysiwygField,
  FadeWrapper,
  ShareLinks,
} from '../../../../components';

import './style.scss';

const NodeStoryDetail = ({ entity, className }) => {
  const { t } = useTranslation();
  const title = entity.getIn(['title', 0, 'value']);
  const nid = entity.getIn(['nid', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed'], '');
  const summary = entity.getIn(['body', 0, 'summary'], '');
  const date = entity.getIn(['field_publication_date', 0, 'value'], entity.getIn(['created', 0, 'value']));
  const image = entity.getIn(['field_media_item', 0]);
  const readTimeInMinutes = entity.getIn(['node_read_time', 0, 'value'], null);

  return (
    <article className="NodeStoryDetail">
      <Container large>
        <Breadcrumbs
          data={[
            { url: '/persoonlijke-verhalen', title: t('entities.stories') },
            { title: title },
          ]}
        />
      </Container>

      {/* Start of Content */}
      <Container>
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="Preface">
              <FadeWrapper>
                <>
                  <div className="Preface__title">
                    <h1>{title}</h1>
                  </div>
                  <div className="Preface__content">
                    <div>
                      <span>{t('entities.story')}, </span>
                      <span className="Preface__content__light">{format((new Date(date)), 'd MMMM y')}</span>
                    </div>
                    {readTimeInMinutes && (
                      <div>
                        <span>{t('general.read_time')}, </span>
                        <span className="Preface__content__light">{readTimeInMinutes} {t('general.minutes_short')}.</span>
                      </div>
                    )}
                  </div>
                </>
              </FadeWrapper>
              <FadeWrapper delay={100}>
                <div className="Preface__body">
                  <WysiwygField
                    property="schema:text"
                    html={summary}
                  />
                </div>
                <ShareLinks />
              </FadeWrapper>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <Hero vertical image={image} />
          </div>
        </div>

      </Container>
      {/* End of Content */}

      {/* Start of Body */}
      <Container small>
        <FadeWrapper delay={300}>
          <WysiwygField
            property="schema:text"
            html={body}
          />
        </FadeWrapper>
      </Container>
      {/* End of Body */}

      {/* Start of paragraphs */}
      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            return (
              <FadeWrapper key={`paragraph:${id}`}>
                <Paragraph
                  id={id}
                  entity={paragraph.get('entity')}
                  nid={nid}
                />
              </FadeWrapper>
            );
          })}
        </div>
      ) : null}
      {/* End of paragraphs */}

    </article>
  );
};

export default NodeStoryDetail;
